import React, { useState, useEffect, useContext } from 'react';
import { useTheme } from 'ThemeContext';
import { SRLWrapper } from 'simple-react-lightbox';
import { AppSettingsContext } from 'AppSettingsContext';
import {
  Wrapper,
  Title,
  Box,
  Item,
  Link,
  Imagebox,
  Image,
  Source
} from './ArticleGallery.style';
import { Breakpoints } from 'assets/Variables.style';
import TitleImages from '../TitleImages';
import { useLazyQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import Bear from 'assets/Images/bear.svg';

const GET_GALLERY = gql`
  query GET_GALLERY($id: Int!) {
    getGallery(gallery_id: $id) {
      name
      images {
        image_url
        name
        description
      }
    }
  }
`;

export function CustomArticleGallery({ id, title = '' }) {
  const [data, setData] = useState(undefined);
  const [loadGallery, { data: galleryData }] = useLazyQuery(GET_GALLERY, {
    variables: {
      id: parseInt(id)
    }
  });

  useEffect(() => {
    if (id) loadGallery();
    return () => {
      setData(undefined);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (galleryData) {
      const { getGallery } = galleryData;
      if (getGallery) {
        setData({
          title: getGallery.name,
          gallery: {
            images:
              getGallery.images &&
              getGallery.images.map(image => ({
                image: image.image_url,
                title: image.name,
                description: image.description
              }))
          }
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [galleryData]);

  return (
    <>
      {data ? (
        <ArticleGallery
          title={data.title || title} // title={title || data.title} <- aktualna wersja chyba działa na stronach szkół, ale na mockach nie, wersja z komentarza działa na mockach, na stronie szkół nie testowano
          images={data.gallery && data.gallery.images}
        />
      ) : (
        ''
      )}
    </>
  );
}

function ArticleGallery({ title = '', images = [] }) {
  const theme = useTheme();
  const [appSettings] = useContext(AppSettingsContext);

  const [options] = useState({
    enablePanzoom: false,
    showThumbnails: false,
    autoplaySpeed: 0,
    captionFontFamily: theme.articleGallery.caption.fontFamily
  });

  return (
    <Wrapper theme={theme.articleGallery.wrapper}>
      {images && images.length > 0 ? (
        <>
          {appSettings.theme === 4 ? (
            title ? (
              <TitleImages
                theme={theme.articleGallery.title}
                title={title}
                imageSrc={Bear}
              />
            ) : (
              ' '
            )
          ) : title ? (
            <Title theme={theme.articleGallery.title}>{title}</Title>
          ) : (
            ' '
          )}
          <SRLWrapper options={options}>
            <Box theme={theme.articleGallery.box}>
              {images
                .filter(image => image.image)
                .map((image, key) => {
                  const regExp = new RegExp('(.*)(.jpg|.jpeg|.png)$');
                  let currentImage = image.thumbnail || image.image;
                  let currentImageTablet;
                  let currentImageMobile;
                  let currentImageMatch;
                  if (currentImage) {
                    currentImageMatch = currentImage.match(regExp);
                    if (
                      currentImageMatch &&
                      currentImageMatch[1] &&
                      currentImageMatch[2]
                    ) {
                      currentImage = `${currentImageMatch[1]}_${theme.articleGallery.image.width}x${theme.articleGallery.image.height}${currentImageMatch[2]}`;
                      currentImageTablet = `${currentImageMatch[1]}_${theme.articleGallery.image.widthMobile}x${theme.articleGallery.image.heightMobile}${currentImageMatch[2]}`;
                      currentImageMobile = `${currentImageMatch[1]}_${theme.articleGallery.image.widthMobile}x${theme.articleGallery.image.heightMobile}${currentImageMatch[2]}`;
                    }
                  }
                  return (
                    <Item key={key}>
                      <Imagebox>
                        {currentImageTablet && (
                          <Source
                            media={`(max-width: ${Breakpoints.md}px)`}
                            srcSet={currentImageTablet}
                          />
                        )}
                        {currentImageMobile && (
                          <Source
                            media={`(max-width: ${Breakpoints.sm}px)`}
                            srcSet={currentImageMobile}
                          />
                        )}
                        <Link
                          href={
                            image.image && /(http(s?)):\/\//gi.test(image.image)
                              ? image.image
                              : `${window.location.origin}${
                                  image.image && image.image[0] === '/'
                                    ? image.image
                                    : `/${image.image}`
                                }`
                          }
                          title={`${image.title} ${
                            image.title && image.description ? '-' : ''
                          } ${image.description}`.trim()}
                          data-attribute='SRL'
                        >
                          <Image
                            src={currentImage}
                            loading='lazy'
                            alt={
                              `${image.title} ${
                                image.title && image.description ? '-' : ''
                              } ${image.description}`.trim() || ' '
                            }
                          />
                        </Link>
                      </Imagebox>
                    </Item>
                  );
                })}
            </Box>
          </SRLWrapper>
        </>
      ) : (
        ''
      )}
    </Wrapper>
  );
}

export default ArticleGallery;
